import React from "react";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { IColumn } from "../vGrid/VGrid";
import { formatCurrency } from "../utils/numberUtils";
import { ApStatus } from "@src/pages/home/children/pricing/components/inventory/components/ApStatus";
import { Marketplaces } from "@src/pages/home/children/pricing/components/inventory/components/Marketplaces";
import helperStyles from "@src/components/helpers.module.scss";

export const columns = (hasEditLockDownCosts: boolean): Array<IColumn<EventInventoryRecord>> => [
	{
		header: "ListingID",
		id: "ListingID",
		accessor: "Listing_ID",
		width: 84,
		sortable: true,
	},
	{
		header: "Section",
		id: "Section",
		accessor: "Section",
		width: 65,
		sortable: true,
	},
	{
		header: "Row",
		id: "Row",
		accessor: "Row",
		getClassName: () => helperStyles.secondaryText,
		width: 50,
		sortable: true,
	},
	{
		header: "Seat",
		id: "Seat",
		accessor: "Seats",
		valueGetter: ({ rowData }) => rowData.Seats || rowData.Seat_Number,
		formatValue: (x, { rowData }) => x || rowData.Seat_Number,
		getClassName: () => helperStyles.secondaryText,
		width: 70,
		sortable: true,
	},
	{
		header: "Quantity",
		id: "Quantity",
		accessor: "Quantity",
		valueGetter: ({ rowData }) => rowData.Quantity || 1,
		formatValue: (x) => x || 1,
		getClassName: () => helperStyles.secondaryText,
		width: 80,
		sortable: true,
	},
	{
		header: "Cost",
		id: "Cost",
		accessor: "Item_Cost",
		valueGetter: ({ rowData }) => (rowData.Quantity ? rowData.Item_Cost / rowData.Quantity : 0),
		formatValue: (x) => formatCurrency(x),
		width: 70,
		sortable: true,
		formatTooltip: (x) => {
			return formatCurrency(x);
		},
		isEditable: (params) => {
			if (!params.rowData.Invoice_ID) return true;
			return !!hasEditLockDownCosts;
		},
		isCurrency: true,
		editableLabel: "Edit Cost",
		setTofixed: 2,
	},
	{
		header: "Price",
		id: "Price",
		accessor: "Item_Price",
		formatValue: (x) => formatCurrency(x),
		width: 70,
		sortable: true,
		formatTooltip: (x) => {
			return formatCurrency(x);
		},
		isCurrency: true,
		editableLabel: "Edit Price",
	},
	{
		header: "Status",
		id: "APStatus",
		accessor: "Is_AutoPriced",
		formatValue: (_x, { rowData }) => <ApStatus disableClick row={rowData} />,
		width: 82,
		sortable: true,
	},
	{
		header: "Marketplaces",
		id: "Marketplaces",
		accessor: "Invoice_ID",
		formatValue: (x, { rowData }) => (x ? "" : <Marketplaces rowData={rowData} />),
		formatTooltip: (_x) => "Marketplaces",
		width: 100,
		sortable: true,
		isEditable: false,
		editableLabel: "Edit Sharing",
		onEditClick: (rowData) => {
			console.info("Edit sharing", rowData);
		},
	},
];
